import gql from 'graphql-tag'

export const GET_COMPANY_CATEGORIES = gql`
query CompanyCategories {
  companyCategories {
    isSuccessful
    message
    companyCategories {
      text
      hasRelation
      companyId
    }
  }
}`

export const GET_COMPANY_PROFILE = gql`
query Company($filter: GetCompanyInput) {
  company(filter: $filter) {
    isSuccessful
    message
    company {
      id
      idleTimeout
      parkTimeout
      offlineTimeout
      fuelGainAlert
      fuelLossAlert
      isActive
      showGeocode
      name
      phoneNo
      faxNo
      taxNo
      category
      companyTag
      email
      domainName
      logoUrl
      dsBase
      dsIntervalType
      dsInitialInterval
      dsInitialBonus
      dsInterval
      dsBonus
      dsCostBrake
      dsCostAccel
      dsCostOverspeed
      dsCostSharpturn
      dsMinScoreA
      dsMinScoreB
      dsMinScoreC
      dsMinScoreD
      bankAccounts {
        bankAccountId
        companyId
        bankName
        accountName
        accountNo
        isDefault
      }
    }
  }
}`

export const UPDATE_COMPANY_PROFILE = gql`
mutation UpdateCompany($input: UpdateCompanyInput!) {
  updateCompany(input: $input) {
    isSuccessful
    message
    company {
      id
      name
    }
  }
}`

export const CREATE_COMPANY_CATEGORIES = gql`
mutation CreateCompanyCategory($input: CreateLookupInputSimple!) {
  createCompanyCategory(input: $input) {
    isSuccessful
    message
    companyCategory {
      text
      companyId
      srcTable
      srcColumn
      hasRelation
    }
  }
}`

export const DELETE_BANK_ACCOUNT = gql`
mutation DeleteBankAccount($input: GetBankAccountInput!) {
  deleteBankAccount(input: $input) {
    isSuccessful
    message
  }
}`